import actionTypes from './action-types';
import { getCategoryList } from './api';
import { API_ERRORS } from 'tradera-utils/api';
import { reload } from 'tradera-utils/location';

const fetchCategoryList = () => dispatch => {
    dispatch(requestCategoryList());

    return getCategoryList()
        .then(results => dispatch(receiveCategoryList(results.data)))
        .catch(error => {
            switch (error.message) {
                case API_ERRORS.VERSION_MISMATCH:
                    reload(true);
                    break;
                case API_ERRORS.CANCELLED:
                    break;
                default:
                    dispatch(handleCategoryListError(error));
                    break;
            }
        });
};

const requestCategoryList = payload => ({
    type: actionTypes.REQUEST_CATEGORY_LIST,
    payload
});

const receiveCategoryList = payload => ({
    type: actionTypes.RECEIVE_CATEGORY_LIST,
    payload
});

const handleCategoryListError = payload => ({
    type: actionTypes.HANDLE_CATEGORY_LIST_ERROR,
    payload
});

export default {
    fetchCategoryList
};
